var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "map", staticStyle: { height: "250px", width: "250px" } },
    [
      _c("div", {
        staticClass: "mapzz",
        on: {
          click: function($event) {
            return _vm.openMapUrl()
          }
        }
      }),
      _vm._v(" "),
      _c("div", {
        staticStyle: { width: "100%", height: "100%" },
        attrs: { id: _vm.uniqueKey }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-99e84de2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-99e84de2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MapItem.vue
// module id = null
// module chunks = 